import { isNullish } from '@y42/util/nullish';
import * as go from 'gojs';

const $ = go.GraphObject.make;
export const subGraphExpanderImageButton = (bindings: go.Binding[] = []) =>
  $(
    'Button',
    {
      'ButtonBorder.spot1': go.Spot.TopLeft,
      'ButtonBorder.spot2': go.Spot.BottomRight,
      'ButtonBorder.fill': 'transparent',
      'ButtonBorder.stroke': 'transparent',
      _buttonFillOver: 'transparent',
      _buttonStrokeOver: 'transparent',
      _buttonFillPressed: 'transparent',
      _buttonStrokePressed: 'transparent',
      width: 20,
      height: 20,
      click,
    },
    ...bindings,
    buttonPicture(),
  );

const buttonPicture = () =>
  $(
    go.Picture,
    {
      name: 'ButtonIcon',
      source: '/assets/images/general/expand.svg',
      desiredSize: new go.Size(13, 8),
    },
    new go.Binding(
      'source',
      'isSubGraphExpanded',
      (expanded) => `/assets/images/general/${expanded ? 'collapse' : 'expand'}.svg`,
    ).ofObject(),
  );

const click = (e: go.InputEvent, object: go.GraphObject) => {
  let group = object.part;
  if (group instanceof go.Adornment) {
    group = group.adornedPart;
  }

  if (!(group instanceof go.Group) || isNullish(e.diagram)) {
    return;
  }

  const cmd = e.diagram.commandHandler;

  if (
    (group.isSubGraphExpanded && !cmd.canCollapseSubGraph(group)) ||
    (!group.isSubGraphExpanded && !cmd.canExpandSubGraph(group))
  ) {
    return;
  }

  e.handled = true;

  if (group.isSubGraphExpanded) {
    cmd.collapseSubGraph(group);
  } else {
    cmd.expandSubGraph(group);
  }
};
